export function online(state, online) {
  state.online = online
}

export function setIsSetup(state, isSetup) {
  state.isSetup = isSetup
}
